import { render, staticRenderFns } from "./CompanyTransport.vue?vue&type=template&id=ab722b66&scoped=true"
import script from "./CompanyTransport.vue?vue&type=script&lang=js"
export * from "./CompanyTransport.vue?vue&type=script&lang=js"
import style0 from "./CompanyTransport.vue?vue&type=style&index=0&id=ab722b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab722b66",
  null
  
)

export default component.exports